import React, { useEffect, useState } from 'react';
import { Avatar, Typography, Button, useMediaQuery } from '@mui/material';
import { ACHIEVEMENT_BY_USERID_API, POST_BY_IDS_API, POST_DETAIL_API } from '../../api/endpoint';
import axiosInstance from '../../api/axiosConfig';
import { useLocation, useParams } from 'react-router-dom';
import counterInstance from '../../api/counterConfig';
import createAxiosInstance from '../../api/axiosConfig';
import comment from '../../assets/comment.png';
import { BorderColor } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import achievementFrame from '../../assets/achievement-Frame.png';
import heartDynamic from '../../assets/heart_dynamic.svg';

const UserAchievements: React.FC = () => {
  const location = useLocation();
  const { userDetail, userId } = location.state || {};
  const [userAchievementData, setUserAchievementData] = useState<any>([]);
  const [pageKey, setPageKey] = useState('');
  const [moreData, setMoreData] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [counter, setCounters] = useState<any>([]);

  const fetchCounters = async (user_id: string, post_id: string) => {
    try {
      const response = await counterInstance.get(`${POST_DETAIL_API}/${user_id}/${post_id}`);
      const results = response.data;
      return results;
    } catch (error) {
      console.error('Error fetching counter data:', error);
    }
  };

  const fetchUserAchievements = async () => {
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${ACHIEVEMENT_BY_USERID_API}${userId}&page=${pageKey}&count=9`);
      if (response.data.page) {
        setPageKey(response.data.page);
      }
      const postIds = response.data.data?.map((item: any) => item.post_id);
      const results = await Promise.all(postIds.map((item: string) => fetchCounters(userId, item)));
      const res = results.map((entry: { Item: any }) => {
        const { Item } = entry;

        const simplified: {
          post_id: string;
          likes?: number;
          user_id?: string;
          comments?: number;
        } = {
          post_id: Item.post_id.S,
          likes: Item.likes.N,
          user_id: Item.user_id.S,
          comments: Item.comments.N
        };

        return simplified;
      });

      setCounters(res);
      const achievements = await axiosInstance.get(`${POST_BY_IDS_API}${postIds.join(',')}`);

      const reorderedPostData = response.data.data
        .map((item: any) => {
          const matchedPost = achievements.data.data.find((work: any) => work.post_id === item.post_id);
          const stats = res.find((stat: any) => stat.post_id === matchedPost.post_id);
          if (matchedPost && stats) {
            return {
              ...matchedPost,
              likes: stats.likes,
              comments: stats.comments
            };
          }
          return matchedPost;
        })
        .filter((post: any) => post !== undefined);

      if (response?.data.data) {
        setUserAchievementData((prevUserData: any) => [...prevUserData, ...reorderedPostData]);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setMoreData(false);
    }
  };

  const handleMore = () => {
    setMoreData(true);
  };

  useEffect(() => {
    if (userId) {
      fetchUserAchievements();
    }
  }, [moreData]);

  const formatDate = (isoString: any) => {
    const date = new Date(isoString);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();
    const time = date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    return `${month} ${day} at ${time}`;
  };

  return (
    <>
      <div>
        <div
          style={{
            fontFamily: 'Baloo 2',
            lineHeight: '120%',
            letterSpacing: isMobile ? 0 : '8px',
            fontSize: isMobile ? '20px' : '48px',
            fontWeight: '800',
            textAlign: 'center',
            marginBottom: isMobile ? '20px' : '1.5rem',
            color: '#ffffff'
          }}>
          {`${userDetail.firstname}'s Achievements`}
        </div>
        <div style={{ marginTop: isMobile ? '40px' : '100px', placeItems: 'center' }}>
          {userAchievementData && userAchievementData.length > 0 ? (
            userAchievementData.map((item: any, index: number) => {
              const formatted = formatDate(item.created_at);
              return (
                <div key={index}>
                  <div style={{ display: 'flex', gap: isMobile ? '20px' : '50px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div
                        style={{
                          width: isMobile ? '20px' : '35px',
                          height: isMobile ? '20px' : '35px',
                          borderRadius: '21.12px',
                          backgroundColor: '#6B5B95',
                          boxShadow: '0 0 9.6px #6B5B95',
                          gap: '10px'
                        }}
                      />
                      <svg style={{ height: '100%', width: isMobile ? '2' : '6' }}>
                        <line
                          x1="1"
                          y1="0"
                          x2="2"
                          y2="100%"
                          rx="80%"
                          ry="80%"
                          stroke="#fff5f5"
                          strokeWidth="6px"
                          strokeDasharray="10,15"
                          strokeOpacity="0.3"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '50px',
                        justifyContent: 'center',
                        gap: '40px',
                        maxWidth: 'fit-content'
                      }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                          sx={{
                            color: '#ffffff',
                            fontFamily: 'Baloo2',
                            fontSize: isMobile ? '12px' : '28.8px',
                            fontWeight: '400',
                            marginTop: isMobile ? 0 : '-10px'
                          }}>
                          {formatted}
                        </Typography>
                        <div
                          style={{
                            width: isMobile ? '219px' : '524px',
                            height: isMobile ? '167px' : '399px',
                            margin: 'auto',
                            marginTop: '10px',
                            marginBottom: '10px',
                            borderRadius: '0.5rem',
                            backgroundImage: `url(${achievementFrame})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}>
                          <img
                            src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${item?.user_id}/WORKS/IMAGES/medium/${item?.files[0]?.name}`}
                            alt="User Work"
                            style={{
                              width: '84%',
                              height: '80%',
                              objectFit: 'cover',
                              borderRadius: '0.5rem',
                              position: 'relative',
                              zIndex: 1
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '15px' : '40px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                          <img
                            src={heartDynamic}
                            alt="Like"
                            style={{
                              width: isMobile ? '21px' : '49px',
                              height: isMobile ? '21px' : '49px',
                              margin: isMobile ? '0' : '5px'
                            }}
                          />
                          <Typography
                            sx={{
                              color: '#ffffff',
                              fontFamily: 'Baloo2',
                              fontSize: isMobile ? '12px' : '24.52px',
                              fontWeight: '600'
                            }}>
                            {item.likes}
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                          <img
                            src={comment}
                            alt="Comment"
                            style={{
                              width: isMobile ? '21px' : '49px',
                              height: isMobile ? '21px' : '49px',
                              margin: isMobile ? '0' : '5px'
                            }}
                          />
                          <Typography
                            sx={{
                              color: '#ffffff',
                              fontFamily: 'Baloo2',
                              fontSize: isMobile ? '12px' : '24.52px',
                              fontWeight: '600'
                            }}>
                            {item.comments}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div>
              <Typography style={{ fontFamily: 'Baloo2', color: 'white' }}>
                You haven&apos;t created any achievement yet!
              </Typography>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UserAchievements;
